define([
    'jquery',
    'module-oneGoogleForm'
], function ($, OneGoogleForm) {

    "use strict";

    var ViewCms = Backbone.View.extend({

        initialize: function(opts){
            var self = this;

            OneGoogleForm.init({
                el: $('.google-form')
            });
        },

        events: {
            
        },
        
        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w <= ORW.responsiveSizes.large) {
                return true;
            }
            return false;
        }

    });

    return ViewCms;

});